import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { apiClient } from '@/lib/api';
import { GUIA_INTERACTIVA_ENDPOINTS } from '@/features/guia-interactiva/api/endpoints';
import type { GuiaInteractivaUsuarioDto } from '@/features/guia-interactiva/types/guia-interactiva.types';

export const GUIA_INTERACTIVA_QUERY_KEY = ['guia-interactiva-status'] as const;

export function useGuiaInteractivaStatusQuery(enabled = true) {
  return useQuery({
    queryKey: GUIA_INTERACTIVA_QUERY_KEY,
    queryFn: () => apiClient<GuiaInteractivaUsuarioDto>(GUIA_INTERACTIVA_ENDPOINTS.MI_PROGRESO),
    enabled,
    staleTime: 5 * 60 * 1000,
    gcTime: 30 * 60 * 1000,
  });
}

export function useMarcarTourVistoMutation() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (codigoTour: string) =>
      apiClient(GUIA_INTERACTIVA_ENDPOINTS.TOUR_VISTO, {
        method: 'POST',
        body: { codigoTour },
      }),
    onSuccess: () => {
      qc.invalidateQueries({ queryKey: GUIA_INTERACTIVA_QUERY_KEY });
    },
  });
}
